import Backbone from 'backbone';
import ko from 'knockout';

import ViewModel from './negativeKeywordListModel';
import template from './negativeKeywordList.pug';
import { setPosition } from './const';

export class NegativeKeywordListContextualAttributeView extends Backbone.View {
  initialize({
    i18n,
  }) {
    this.i18n = i18n;
    this.viewModel = new ViewModel({
      i18n,
    });
  }

  render() {
    this.viewModel.updateAttribute();
    this.$el.html(template());
    ko.applyBindings(this.viewModel, this.el);
    const container = this.$el.children('.contextual-tooltip-container');
    setPosition(container);
    return this;
  }
}
